<template>
    <div id="index" ref="appRef">
        <dv-loading v-show="loading">Loading...</dv-loading>
        <div class="bg">
            <!-- 返回按钮 -->
            <!-- <div class="back" @click="back">
                <span style="font-size: 26px;">←</span>
                <span style="margin-left: 8px;font-size: 26px;">{{ $t('common.back') }}</span>
            </div> -->

            <!-- 头部模块 -->
            <div class="header">
                <ul class="left">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <div class="title">
                    <span>{{ $t('threePhase.title') }}</span>
                </div>
                <ul class="right">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>

            <!-- 中间地区 -->
            <div class="main">
                <!-- 左侧模块 -->
                <div class="main-left">
                    <!-- 完成率 -->
                    <div class="completion">
                        <div class="completion-content">
                            <div class="rate">
                                <h5><span>{{ $t('threePhase.onlineRate') }}</span></h5>
                                <p>67%</p>
                            </div>
                        </div>
                    </div>
                    <!-- 闪电 -->
                    <div class="lightning">
                        <div class="lightning1">
                            <div class="sd1">
                                <canvas ref="canvas1"></canvas>
                            </div>
                            <div class="jd1">
                                <ul class="cd">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <div class="box">
                                    <span>{{ $t('threePhase.voltageA') }}</span>
                                </div>

                            </div>
                        </div>
                        <div class="lightning2">
                            <div class="sd2">
                                <canvas ref="canvas2"></canvas>
                            </div>
                            <div class="jd2">
                                <ul class="cd">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <div class="box">
                                    <span>{{ $t('threePhase.voltageB') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- top3 -->
                    <div class="top3">
                        <ul>
                            <li @click="toggleContent">
                                <div class="content">
                                    <div style="display: flex;width: 100%;height: 70px;">
                                        <span style="font-size: 18px;color: #f985a4;">{{ $t('threePhase.combinedPhase') }}</span>
                                    </div>
                                </div>
                            </li>
                            <li @click="togmap">
                                <div class="content">
                                    <div style="display: flex;justify-content: center;
                                            align-items: center;width: 100%;height: 70px;margin-top: 30px;">
                                        <span style="font-size: 18px;color: #1fce9f;">{{ $t('threePhase.positioning') }}</span>
                                    </div>
                                </div>
                            </li>
                            <!-- <li>
                        <div class="title">{{ $t('threePhase.tbd') }}</div>
                        <div class="content">
                     
                            <span>{{ $t('threePhase.button') }}3</span>
                        </div>
                    </li> -->
                        </ul>
                    </div>
                </div>

                <!-- 中间模块 -->
                <div class="main-middle">
                    <div class="external1"></div>
                    <div class="external2"></div>
                    <div class="external3"></div>
                    <div class="external4">
                        <p>{{ $t('threePhase.projectName') }}: ssss</p>
                    </div>
                    <!-- 加载 -->
                    <div class="jz1" v-if="barChartType == 1">
                        <ul>
                            <li v-for="(item, index) in items1" :key="'1-' + index" :style="{ opacity: item.opacity }">
                            </li>
                        </ul>
                    </div>
                    <div class="jz2" v-if="barChartType == 1">
                        <ul>
                            <li v-for="(item, index) in items1" :key="'2-' + index" :style="{ opacity: item.opacity }">
                            </li>
                        </ul>
                    </div>
                    <!-- 内边框 -->
                    <div class="inner1" id="inner1" v-if="barChartType == 1"></div>
                    <div class="inner2" v-if="barChartType == 1"></div>
                    <!-- 内加载箭头模块 -->
                    <div class="arrow-l" v-if="barChartType == 1">
                        <ol>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ol>
                    </div>
                    <div class="arrow-r" v-if="barChartType == 1">
                        <ol>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ol>
                    </div>
                    <!-- 中间仪表图 -->
                    <div class="meter" v-if="barChartType == 1"></div>
                    <!-- 中间背景canvas -->
                    <div class="animate" ref="animateContainer" v-if="barChartType == 1"></div>
                    <!-- 柱状图容器 -->
                    <div class="chart-container" style="margin-top: 30px;" v-if="barChartType == 2">
                        <barChart :photovoltaicType="1"></barChart>
                    </div>
                    <!-- 地图 -->
                    <div class="chart-container" style="margin-top: 70px;padding: 10px;" v-if="barChartType == 3">
                        <mapView :photovoltaicType="1"></mapView>
                    </div>
                    <!-- 销售额 -->
                    <div class="sale" v-if="barChartType == 1">
                        <p><span>{{ $t('threePhase.threePhase') }}</span></p>
                        <p><span>6593625</span></p>
                    </div>
                </div>
                <!-- 右侧模块 -->
                <div class="main-right">
                    <!-- 同比 -->
                    <div class="compare">
                        <div class="compare-content">
                            <div class="rate2">
                                <h5><span>{{ $t('threePhase.compare') }}</span></h5>
                                <p>0.58</p>
                            </div>
                        </div>
                    </div>
                    <!-- 闪电 -->
                    <div class="lightning">
                        <div class="lightning3">
                            <div class="jd3">
                                <div class="box">
                                    <span>{{ $t('threePhase.voltageC') }}</span>
                                </div>
                                <ul class="cd">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                            <div class="sd3">
                                <canvas ref="canvas3"></canvas>
                            </div>
                        </div>
                        <div class="lightning4">
                            <div class="jd4">
                                <div class="box">
                                    <span>{{ $t('threePhase.phaseVoltage') }}</span>
                                </div>
                                <ul class="cd">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                            <div class="sd4">
                                <canvas ref="canvas4"></canvas>
                            </div>
                        </div>
                    </div>
                    <!-- top6 -->
                    <!-- <div class="top6">
                        <ul>
                            <li>
                                <div class="title">{{ $t('threePhase.tbd') }}</div>
                                <div class="content">

                                    <span>{{ $t('threePhase.button') }}4</span>
                                </div>
                            </li>
                            <li>
                                <div class="title">{{ $t('threePhase.tbd') }}</div>
                                <div class="content">

                                    <span>{{ $t('threePhase.button') }}5</span>
                                </div>
                            </li>
                            <li>
                                <div class="title">{{ $t('threePhase.tbd') }}</div>
                                <div class="content">

                                    <span>{{ $t('threePhase.button') }}6</span>
                                </div>
                            </li>
                        </ul>
                    </div> -->
                </div>

            </div>
            <!-- 底部模块 -->
            <div class="bottom">
                <div class="ul-box">
                    <ul>
                        <li>
                            <div class="li-content">
                                <p><span>{{ $t('threePhase.phaseA') }}</span></p>
                                <p><span>226933</span></p>
                                <div class="li-box">
                                    <div class="box1">
                                        <h5><span>{{ $t('threePhase.harmonicDistortion') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/wc.png" alt="">
                                            <span>54.6%</span>
                                        </div>
                                    </div>
                                    <div class="box2">
                                        <h5><span>{{ $t('threePhase.current') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/zc.png" alt="">
                                            <span>74.6%</span>
                                        </div>
                                    </div>
                                    <div class="box3">
                                        <h5><span>{{ $t('threePhase.power') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/sq.png" alt="">
                                            <span>25.3%</span>
                                        </div>
                                    </div>
                                    <div class="box4">
                                        <h5><span>{{ $t('threePhase.powerFactor') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/tb.png" alt="">
                                            <span>55.3%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="li-content">
                                <p><span>{{ $t('threePhase.phaseB') }}</span></p>
                                <p><span>226933</span></p>
                                <div class="li-box">
                                    <div class="box1">
                                        <h5><span>{{ $t('threePhase.harmonicDistortion') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/wc.png" alt="">
                                            <span>54.6%</span>
                                        </div>
                                    </div>
                                    <div class="box2">
                                        <h5><span>{{ $t('threePhase.current') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/zc.png" alt="">
                                            <span>74.6%</span>
                                        </div>
                                    </div>
                                    <div class="box3">
                                        <h5><span>{{ $t('threePhase.power') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/sq.png" alt="">
                                            <span>25.3%</span>
                                        </div>
                                    </div>
                                    <div class="box4">
                                        <h5><span>{{ $t('threePhase.powerFactor') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/tb.png" alt="">
                                            <span>55.3%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="li-content">
                                <p><span>{{ $t('threePhase.phaseC') }}</span></p>
                                <p><span>226933</span></p>
                                <div class="li-box">
                                    <div class="box1">
                                        <h5><span>{{ $t('threePhase.harmonicDistortion') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/wc.png" alt="">
                                            <span>54.6%</span>
                                        </div>
                                    </div>
                                    <div class="box2">
                                        <h5><span>{{ $t('threePhase.current') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/zc.png" alt="">
                                            <span>74.6%</span>
                                        </div>
                                    </div>
                                    <div class="box3">
                                        <h5><span>{{ $t('threePhase.power') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/sq.png" alt="">
                                            <span>25.3%</span>
                                        </div>
                                    </div>
                                    <div class="box4">
                                        <h5><span>{{ $t('threePhase.powerFactor') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/tb.png" alt="">
                                            <span>55.3%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <div class="li-content">
                                <p><span>{{ $t('threePhase.phaseA') }}</span></p>
                                <p><span>226933</span></p>
                                <div class="li-box">
                                    <div class="box1">
                                        <h5><span>{{ $t('threePhase.harmonicDistortion') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/wc.png" alt="">
                                            <span>54.6%</span>
                                        </div>
                                    </div>
                                    <div class="box2">
                                        <h5><span>{{ $t('threePhase.current') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/zc.png" alt="">
                                            <span>74.6%</span>
                                        </div>
                                    </div>
                                    <div class="box3">
                                        <h5><span>{{ $t('threePhase.power') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/sq.png" alt="">
                                            <span>25.3%</span>
                                        </div>
                                    </div>
                                    <div class="box4">
                                        <h5><span>{{ $t('threePhase.powerFactor') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/tb.png" alt="">
                                            <span>55.3%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="li-content">
                                <p><span>{{ $t('threePhase.phaseB') }}</span></p>
                                <p><span>226933</span></p>
                                <div class="li-box">
                                    <div class="box1">
                                        <h5><span>{{ $t('threePhase.harmonicDistortion') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/wc.png" alt="">
                                            <span>54.6%</span>
                                        </div>
                                    </div>
                                    <div class="box2">
                                        <h5><span>{{ $t('threePhase.current') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/zc.png" alt="">
                                            <span>74.6%</span>
                                        </div>
                                    </div>
                                    <div class="box3">
                                        <h5><span>{{ $t('threePhase.power') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/sq.png" alt="">
                                            <span>25.3%</span>
                                        </div>
                                    </div>
                                    <div class="box4">
                                        <h5><span>{{ $t('threePhase.powerFactor') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/tb.png" alt="">
                                            <span>55.3%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="li-content">
                                <p><span>{{ $t('threePhase.phaseC') }}</span></p>
                                <p><span>226933</span></p>
                                <div class="li-box">
                                    <div class="box1">
                                        <h5><span>{{ $t('threePhase.harmonicDistortion') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/wc.png" alt="">
                                            <span>54.6%</span>
                                        </div>
                                    </div>
                                    <div class="box2">
                                        <h5><span>{{ $t('threePhase.current') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/zc.png" alt="">
                                            <span>74.6%</span>
                                        </div>
                                    </div>
                                    <div class="box3">
                                        <h5><span>{{ $t('threePhase.power') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/sq.png" alt="">
                                            <span>25.3%</span>
                                        </div>
                                    </div>
                                    <div class="box4">
                                        <h5><span>{{ $t('threePhase.powerFactor') }}</span></h5>
                                        <div class="pic">
                                            <img src="../../assets/threePhase/tb.png" alt="">
                                            <span>55.3%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>


        </div>

    </div>
</template>


<script>
import drawMixin from "../../utils/drawMixin";
import barChart from '@/components/threePhase/barChart'
import mapView from '@/components/threePhase/map'

// import { deviceListAPI, batteryAPI } from "@/api";

export default {
    name: 'threePhase',
    mixins: [drawMixin],
    components: {
        barChart,
        mapView
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        }
    },
    data() {
        return {
            // 1 for default display, 2 for bar chart, 3 for map
            barChartType: 1,
            loading: false,
            hue1: 180,
            hue2: 300,
            items1: [
                { opacity: 1 },
                { opacity: 0.9 },
                { opacity: 0.8 },
                { opacity: 0.7 },
                { opacity: 0.6 },
                { opacity: 0.5 },
                { opacity: 0.4 },
                { opacity: 0.3 },
                { opacity: 0.2 },
                { opacity: 0.1 },
            ],
            color1: 'hsl(180, 90%, 70%)',
            color2: 'hsl(300, 90%, 70%)',
            animationData: {
                1: { interval: null, moveInterval: null, ctx: null, pt1: null, pt2: null, width: 0, height: 0, step: 0 },
                2: { interval: null, moveInterval: null, ctx: null, pt1: null, pt2: null, width: 0, height: 0, step: 0 },
                3: { interval: null, moveInterval: null, ctx: null, pt1: null, pt2: null, width: 0, height: 0, step: 0 },
                4: { interval: null, moveInterval: null, ctx: null, pt1: null, pt2: null, width: 0, height: 0, step: 0 },
            },
            App: null,
            animationId: null,
            animationRunning: true,
            w: 8 // 网格大小系数
        }
    },
    created() {
        if (localStorage.getItem('lang')) {
            this.$i18n.locale = localStorage.getItem('lang')
        }
    },
    mounted() {
        document.title = this.$t('threePhase.threePhase')

        this.$nextTick(() => {
            this.initAnimation(1);
            this.initAnimation(2);
            this.initAnimation(3);
            this.initAnimation(4);
            this.jzUlLi()
            this.initAnimation2();
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        // 清除所有定时器
        for (let i = 1; i <= 4; i++) {
            if (this.animationData[i].interval) clearInterval(this.animationData[i].interval);
            if (this.animationData[i].moveInterval) clearInterval(this.animationData[i].moveInterval);
        }
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
        this.stopAnimation();
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        // 返回
        back() {
            this.$router.back();
        },

        toggleContent() {
            if(this.barChartType == 1) {
                this.barChartType = 2
            }else {
                this.barChartType = 1
                this.$nextTick(() => {
                    this.initAnimation2();
                });
            }
        },

        togmap() {
            console.log(this.barChartType);
            if(this.barChartType != 3) {
                this.barChartType = 3
            }
        },



        jzUlLi() {
            this.stopAnimation();

            this.intervalId = setInterval(() => {
                // 更新第一个加载器
                this.items1 = this.items1.map(item => {
                    let opacity = item.opacity - 0.1;
                    if (opacity <= 0) opacity = 1;
                    return { opacity: parseFloat(opacity.toFixed(2)) };
                });
            }, 100);
        },
        stopAnimation() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },

        initAnimation2() {
            // 清除现有canvas
            const container = this.$refs.animateContainer;
            container.innerHTML = '';

            // 创建App对象
            this.App = {
                canvas: null,
                ctx: null,
                width: 0,
                height: 0,
                dataToImageRatio: 1,
                stepCount: 0,
                particles: [],
                lifespan: 1000,
                popPerBirth: 1,
                maxPop: 200,
                birthFreq: 5,
                grid: [],
                gridSize: 8,
                gridSteps: 0,
                gridMaxIndex: 0,
                xC: 0,
                yC: 0,
                deathCount: 0,
                drawnInLastFrame: 0,

                setup: function () {
                    // 创建canvas元素，并加入容器中
                    var canvas = document.createElement('canvas');

                    // 控制canvas幕布的大小
                    const container = this.$parent.$refs.animateContainer;
                    canvas.width = container.clientWidth;
                    canvas.height = container.clientHeight;

                    this.canvas = canvas;
                    container.appendChild(canvas);
                    this.ctx = this.canvas.getContext('2d');
                    this.width = this.canvas.width;
                    this.height = this.canvas.height;
                    this.dataToImageRatio = 1;
                    this.ctx.imageSmoothingEnabled = false;
                    this.ctx.webkitImageSmoothingEnabled = false;
                    this.ctx.msImageSmoothingEnabled = false;
                    this.xC = this.width / 2;
                    this.yC = this.height / 2;

                    this.stepCount = 0;
                    this.particles = [];
                    this.lifespan = 1000;
                    this.popPerBirth = 1;
                    this.maxPop = 200;
                    this.birthFreq = 5;

                    // Build grid
                    this.gridSize = 8;
                    this.gridSteps = Math.floor(1000 / this.gridSize);
                    this.grid = [];
                    var i = 0;
                    for (var xx = -500; xx < 500; xx += this.gridSize) {
                        for (var yy = -500; yy < 500; yy += this.gridSize) {
                            // 径向场，r的三角函数，最大值在r0附近
                            var r = Math.abs(xx) + Math.abs(yy),
                                r0 = 3 * this.$parent.w,
                                field;

                            if (r < r0) field = 255 / r0 * r;
                            else if (r > r0) field = 255 - Math.min(255, (r - r0) / 2);

                            this.grid.push({
                                x: xx,
                                y: yy,
                                busyAge: 0,
                                spotIndex: i,
                                isEdge: (xx == -500 ? 'left' :
                                    (xx == (-500 + this.gridSize * (this.gridSteps - 1)) ? 'right' :
                                        (yy == -500 ? 'top' :
                                            (yy == (-500 + this.gridSize * (this.gridSteps - 1)) ? 'bottom' :
                                                false
                                            )
                                        )
                                    )
                                ),
                                field: field
                            });
                            i++;
                        }
                    }
                    this.gridMaxIndex = i;

                    this.initDraw();
                },

                evolve: function () {
                    if (!this.$parent.animationRunning) return;

                    this.stepCount++;

                    // Increment all grid ages
                    this.grid.forEach(function (e) {
                        if (e.busyAge > 0) e.busyAge++;
                    });

                    if (this.stepCount % this.birthFreq == 0 && (this.particles.length + this.popPerBirth) < this.maxPop) {
                        this.birth();
                    }
                    this.move();
                    this.draw();
                },

                birth: function () {
                    var gridSpotIndex = Math.floor(Math.random() * this.gridMaxIndex),
                        gridSpot = this.grid[gridSpotIndex],
                        x = gridSpot.x,
                        y = gridSpot.y;

                    var particle = {
                        hue: -10,
                        sat: 95,
                        lum: 20 + Math.floor(40 * Math.random()),
                        x: x,
                        y: y,
                        xLast: x,
                        yLast: y,
                        xSpeed: 0,
                        ySpeed: 0,
                        age: 0,
                        ageSinceStuck: 0,
                        attractor: {
                            oldIndex: gridSpotIndex,
                            gridSpotIndex: gridSpotIndex,
                        },
                        name: 'seed-' + Math.ceil(10000000 * Math.random())
                    };
                    this.particles.push(particle);
                },

                kill: function (particleName) {
                    // 使用原生JavaScript替代lodash的reject方法
                    var newArray = this.particles.filter(function (seed) {
                        return seed.name !== particleName;
                    });
                    // 使用JSON方法替代lodash的cloneDeep
                    this.particles = JSON.parse(JSON.stringify(newArray));
                },

                move: function () {
                    for (var i = 0; i < this.particles.length; i++) {
                        // Get particle
                        var p = this.particles[i];

                        // Save last position
                        p.xLast = p.x;
                        p.yLast = p.y;

                        // Attractor and corresponding grid spot
                        var index = p.attractor.gridSpotIndex,
                            gridSpot = this.grid[index];

                        // Maybe move attractor and with certain constraints
                        if (Math.random() < 0.5) {
                            // Move attractor
                            if (!gridSpot.isEdge) {
                                // Change particle's attractor grid spot and local move function's grid spot
                                var topIndex = index - 1,
                                    bottomIndex = index + 1,
                                    leftIndex = index - this.gridSteps,
                                    rightIndex = index + this.gridSteps,
                                    topSpot = this.grid[topIndex],
                                    bottomSpot = this.grid[bottomIndex],
                                    leftSpot = this.grid[leftIndex],
                                    rightSpot = this.grid[rightIndex];

                                // Choose neighbour with highest field value (with some desobedience...)
                                var chaos = 30;

                                // 使用原生JavaScript替代lodash的maxBy方法
                                var maxField = -Infinity;
                                var maxFieldSpot = null;

                                [topSpot, bottomSpot, leftSpot, rightSpot].forEach(function (e) {
                                    var fieldValue = e.field + chaos * Math.random();
                                    if (fieldValue > maxField) {
                                        maxField = fieldValue;
                                        maxFieldSpot = e;
                                    }
                                });

                                var potentialNewGridSpot = maxFieldSpot;
                                if (potentialNewGridSpot.busyAge == 0 || potentialNewGridSpot.busyAge > 15) {
                                    p.ageSinceStuck = 0;
                                    p.attractor.oldIndex = index;
                                    p.attractor.gridSpotIndex = potentialNewGridSpot.spotIndex;
                                    gridSpot = potentialNewGridSpot;
                                    gridSpot.busyAge = 1;
                                } else {
                                    p.ageSinceStuck++;
                                }

                            } else {
                                p.ageSinceStuck++;
                            }

                            if (p.ageSinceStuck == 10) this.kill(p.name);
                        }

                        // Spring attractor to center with viscosity
                        var k = 8, visc = 0.4;
                        var dx = p.x - gridSpot.x,
                            dy = p.y - gridSpot.y,
                            dist = Math.sqrt(dx * dx + dy * dy);

                        // Spring
                        var xAcc = -k * dx,
                            yAcc = -k * dy;

                        p.xSpeed += xAcc;
                        p.ySpeed += yAcc;

                        // Calm the f*ck down
                        p.xSpeed *= visc;
                        p.ySpeed *= visc;

                        // Store stuff in particle brain
                        p.speed = Math.sqrt(p.xSpeed * p.xSpeed + p.ySpeed * p.ySpeed);
                        p.dist = dist;

                        // Update position
                        p.x += 0.1 * p.xSpeed;
                        p.y += 0.1 * p.ySpeed;

                        // Get older
                        p.age++;

                        // Kill if too old
                        if (p.age > this.lifespan) {
                            this.kill(p.name);
                            this.deathCount++;
                        }
                    }
                },

                initDraw: function () {
                    this.ctx.beginPath();
                    this.ctx.rect(0, 0, this.width, this.height);
                    this.ctx.fillStyle = 'transparent';
                    this.ctx.fill();
                    this.ctx.closePath();
                },

                draw: function () {
                    this.drawnInLastFrame = 0;
                    if (!this.particles.length) return false;

                    this.ctx.beginPath();
                    this.ctx.rect(0, 0, this.width, this.height);
                    this.ctx.fillStyle = 'rgba(12, 22, 25, 0.1)';
                    this.ctx.fill();
                    this.ctx.closePath();

                    for (var i = 0; i < this.particles.length; i++) {
                        // Draw particle
                        var p = this.particles[i];

                        var h = p.hue + this.stepCount / 30;
                        var s = p.sat;
                        var l = p.lum;
                        var a = 1;

                        var last = this.dataXYtoCanvasXY(p.xLast, p.yLast);
                        var now = this.dataXYtoCanvasXY(p.x, p.y);
                        var attracSpot = this.grid[p.attractor.gridSpotIndex];
                        var attracXY = this.dataXYtoCanvasXY(attracSpot.x, attracSpot.y);
                        var oldAttracSpot = this.grid[p.attractor.oldIndex];
                        var oldAttracXY = this.dataXYtoCanvasXY(oldAttracSpot.x, oldAttracSpot.y);

                        this.ctx.beginPath();

                        this.ctx.strokeStyle = 'hsl(145, 80%, 50%)';
                        this.ctx.fillStyle = 'hsla(' + h + ', ' + s + '%, ' + l + '%, ' + a + ')';

                        // Particle trail
                        this.ctx.moveTo(last.x, last.y);
                        this.ctx.lineTo(now.x, now.y);

                        this.ctx.lineWidth = 1.5 * this.dataToImageRatio;
                        this.ctx.stroke();
                        this.ctx.closePath();

                        // Attractor positions
                        this.ctx.beginPath();
                        this.ctx.lineWidth = 1.5 * this.dataToImageRatio;
                        this.ctx.moveTo(oldAttracXY.x, oldAttracXY.y);
                        this.ctx.lineTo(attracXY.x, attracXY.y);
                        this.ctx.arc(attracXY.x, attracXY.y, 1.5 * this.dataToImageRatio, 0, 2 * Math.PI, false);

                        this.ctx.strokeStyle = 'hsl(145, 80%, 40%)';
                        this.ctx.fillStyle = 'hsl(145, 80%, 40%)';
                        this.ctx.fill();

                        this.ctx.closePath();

                        // UI counter
                        this.drawnInLastFrame++;
                    }
                },

                dataXYtoCanvasXY: function (x, y) {
                    var zoom = 1.6;
                    var xx = this.xC + x * zoom * this.dataToImageRatio;
                    var yy = this.yC + y * zoom * this.dataToImageRatio;

                    return { x: xx, y: yy };
                }
            };

            // 设置Vue实例引用
            this.App.$parent = this;

            // 初始化并启动动画
            this.App.setup();

            const frame = () => {
                this.App.evolve();
                this.animationId = requestAnimationFrame(frame);
            };
            this.animationId = requestAnimationFrame(frame);
        },

        handleResize2() {
            // 防抖处理
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.restartAnimation2();
            }, 250);
        },

        restartAnimation2() {
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
            }
            this.initAnimation2();
        },

        initAnimation(num) {
            const canvas = this.$refs[`canvas${num}`];
            if (!canvas) return;

            const data = this.animationData[num];

            // 设置canvas尺寸
            data.width = 230
            data.height = canvas.clientHeight;
            canvas.width = data.width;
            canvas.height = data.height;

            // 获取上下文
            data.ctx = canvas.getContext('2d');

            // 初始化闪电起点和终点
            if (num <= 2) {
                data.pt1 = { x: -20, y: data.height / 2 };
                data.pt2 = { x: -20, y: data.height / 2 };
            } else {
                data.pt1 = { x: data.width + 20, y: data.height / 2 }; // 起点在右侧外部
                data.pt2 = { x: data.width + 20, y: data.height / 2 }; // 起点在右侧外部
            }



            // 绘制背景
            this.drawBackground(num);

            // 开始动画
            this.startAnimation(num);
        },

        startAnimation(num) {
            const data = this.animationData[num];

            // 清除现有动画
            if (data.interval) clearInterval(data.interval);
            if (data.moveInterval) clearInterval(data.moveInterval);

            // 设置动画循环
            data.interval = setInterval(() => {
                this.animate(num);
            }, 60);

            // 设置闪电移动
            setTimeout(() => {
                if (num <= 2) {
                    data.moveInterval = setInterval(() => {
                        data.pt1.x += 10;
                        if (data.pt1.x > data.width - 10) {
                            clearInterval(data.moveInterval);
                        }
                    }, 60);
                } else {
                    data.moveInterval = setInterval(() => {
                        data.pt1.x -= 10;
                        if (data.pt1.x < 10) {
                            clearInterval(data.moveInterval);
                        }
                    }, 60);
                }
            }, 1000);
        },

        animate(num) {
            const data = this.animationData[num];
            data.step++;

            this.blur(num, 1);
            this.draw(num);
            this.fade(num, 0.1);
        },

        draw(num) {
            const data = this.animationData[num];
            if (!data.ctx) return;

            let iterations = [data.pt1, data.pt2];
            let newiterations, i, j;

            for (i = 0; i < 8; i++) {
                newiterations = [iterations[0]];
                for (j = 1; j < iterations.length; j++) {
                    newiterations.push(this.getRandMidpoint(iterations[j - 1], iterations[j], 200 / (i * i + 1)));
                    newiterations.push(iterations[j]);
                }
                iterations = newiterations.concat([]);
            }

            data.ctx.beginPath();
            data.ctx.moveTo(iterations[0].x, iterations[0].y);
            data.ctx.lineWidth = 2;
            data.ctx.strokeStyle = this[`color1`];

            for (i = 1; i < iterations.length; i++) {
                data.ctx.lineTo(iterations[i].x, iterations[i].y);
            }

            data.ctx.stroke();
            data.ctx.closePath();
        },

        getRandMidpoint(pa, pb, range) {
            const a = Math.atan2(pb.y - pa.y, pb.x - pa.x) + Math.PI / 2;
            const half = { y: (pb.y - pa.y) / 2 + pa.y, x: (pb.x - pa.x) / 2 + pa.x };
            const offset = Math.random() * range / 3 - range / 6;

            return {
                x: Math.cos(a) * offset + half.x,
                y: Math.sin(a) * offset + half.y
            };
        },

        blur(num, amt) {
            const data = this.animationData[num];
            const canvas = this.$refs[`canvas${num}`];
            data.ctx.filter = `blur(${amt}px)`;
            data.ctx.drawImage(canvas, 0, 0);
            data.ctx.filter = 'none';
        },

        fade(num, amt) {
            const data = this.animationData[num];

            data.ctx.beginPath();
            data.ctx.rect(0, 0, data.width, data.height);
            data.ctx.fillStyle = `rgba(4, 10, 11, ${amt})`;
            data.ctx.fill();
        },

        drawBackground(num) {
            const data = this.animationData[num];

            data.ctx.beginPath();
            data.ctx.rect(0, 0, data.width, data.height);
            data.ctx.fillStyle = 'rgba(4, 10, 11, 1)';
            data.ctx.fill();
        },

        restartAnimation(num) {
            this.initAnimation(num);
        },

        randomColor(num) {
            const hue = Math.floor(Math.random() * 360);
            this[`hue${num}`] = hue;
            this[`color${num}`] = `hsl(${hue}, 90%, 70%)`;
        },

        updateColor(num) {
            this[`color${num}`] = `hsl(${this[`hue${num}`]}, 90%, 70%)`;
        },

        handleResize() {
            // 重新初始化动画以适应新尺寸
            // this.initAnimation(1);
            // this.initAnimation(2);
        }
    },
};
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'YeJingShuZi';
    src: url('../../assets/threePhase/液晶数字字体.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

#index {
    color: #d3d6dd;
    width: 1920px;
    height: 1080px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
    overflow: hidden;

    .bg {
        width: 100%;
        height: 100%;
        background-image: url("../../assets/threePhase/background.png");
        background-size: cover;
        background-position: center center;
    }
}

.back {
    position: absolute;
    top: 50px;
    left: 20px;
    color: #65ffff;
    font-size: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all 0.3s ease;
}

.back:hover {
    transform: scale(1.2);
    text-shadow: 1px 1px 2px #0a7988;
}

.header {
    width: 75%;
    height: 10%;
    margin: auto;
}

.header>div {
    float: left;
}

.header .title {
    height: 100%;
    width: 40%;
    text-align: center;
    color: #fff;
    font-size: 2.4rem;
    display: table;
    opacity: 0;
    animation: zoomIn 0.5s linear forwards 0.8s;
}

.header .title span {
    display: table-cell;
    vertical-align: middle;
}

.header .left,
.header .right {
    width: 30%;
    height: 100%;
    float: left;
}

.header .left li,
.header .right li {
    width: 3.5rem;
    height: 1rem;
    background-color: #02b687;
    opacity: 0;
    margin: 0 2%;
    float: left;
    border-radius: 1rem;
    margin-top: 10%;
}

.header .left li:nth-of-type(1) {
    animation: show1 0.2s linear forwards;
}

.header .left li:nth-of-type(2) {
    animation: show2 0.2s linear forwards 0.2s;
}

.header .left li:nth-of-type(3) {
    animation: show3 0.2s linear forwards 0.4s;
}

.header .left li:nth-of-type(4) {
    animation: show4 0.2s linear forwards 0.6s;
}

.header .right li {
    float: right;
}

.header .right li:nth-of-type(1) {
    animation: show1 0.2s linear forwards;
}

.header .right li:nth-of-type(2) {
    animation: show2 0.2s linear forwards 0.2s;
}

.header .right li:nth-of-type(3) {
    animation: show3 0.2s linear forwards 0.4s;
}

.header .right li:nth-of-type(4) {
    animation: show4 0.2s linear forwards 0.6s;
}

.main {
    width: 100%;
    height: 60%;
}

.main>div {
    float: left;
}

.main .main-left {
    width: 22.5%;
    height: 100%;
}

.main .main-left .completion {
    width: 100%;
    height: 30%;
    position: relative;
}

.main .main-left .completion .completion-content {
    width: 10rem;
    height: 10rem;
    background: url("../../assets/threePhase/border.png") no-repeat center;
    background-size: contain;
    position: absolute;
    left: -50%;
    top: 50%;
    transform: translate(-50%, -50%);
    animation: animate1 1s linear forwards 3s;
}

.main .main-left .completion .completion-content .rate {
    width: 6rem;
    height: 6rem;
    position: absolute;
    left: 15%;
    top: 51%;
    transform: translateY(-50%);
    background: url("../../assets/threePhase/cricle.png") no-repeat center;
    background-size: contain;
    animation: rotate1 5s ease infinite;
}

.main .main-left .completion .completion-content .rate h5 {
    text-align: center;
    height: 50%;
    width: 100%;
    color: #fff;
    display: table;
}

.main .main-left .completion .completion-content .rate h5 span {
    display: table-cell;
    vertical-align: bottom;
    font-size: 0.8rem;
}

.main .main-left .completion .completion-content .rate p {
    text-align: center;
    height: 50%;
    width: 100%;
    color: #fff;
    display: table;
}

.main .main-left .completion .completion-content .rate p span {
    display: table-cell;
    vertical-align: middle;
}

.main .main-left .lightning {
    width: 100%;
    height: 40%;
}

.main .main-left .lightning .lightning1,
.main .main-left .lightning .lightning2 {
    width: 100%;
    height: 50%;
}

.main .main-left .lightning .lightning1>div {
    float: left;
}

.main .main-left .lightning .lightning1 .sd1 {
    width: 55%;
    height: 100%;
}

.main .main-left .lightning .lightning1 .jd1 {
    width: 45%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-top: 10px;
}

.main .main-left .lightning .lightning1 .jd1>div {
    // float: left;
}

.main .main-left .lightning .lightning1 .jd1 ul {
    display: flex;
    align-items: center;
}

.main .main-left .lightning .lightning1 .jd1 ul li {
    margin-right: 0.15rem;
    background-color: #00e4c8;
    border-radius: 50%;
    opacity: 0;
}

.main .main-left .lightning .lightning1 .jd1 ul li:nth-of-type(1) {
    width: 0.6rem;
    height: 0.6rem;
    animation: show4 0.1s linear forwards 2.5s;
}

.main .main-left .lightning .lightning1 .jd1 ul li:nth-of-type(2) {
    width: 0.7rem;
    height: 0.7rem;
    animation: show4 0.1s linear forwards 2.6s;
}

.main .main-left .lightning .lightning1 .jd1 ul li:nth-of-type(3) {
    width: 0.8rem;
    height: 0.8rem;
    animation: show4 0.1s linear forwards 2.7s;
}

.main .main-left .lightning .lightning1 .jd1 ul li:nth-of-type(4) {
    width: 0.9rem;
    height: 0.9rem;
    animation: show4 0.1s linear forwards 2.8s;
}

.main .main-left .lightning .lightning1 .jd1 .box {
    width: 6rem;
    /* 保持2rem */
    height: 2.6rem;
    /* 调整高度为1.6rem */
    background-color: #00e4c8;
    border-radius: 0.4rem;
    /* 修改为0.4rem以形成圆滑的方形 */
    opacity: 0;
    animation: show4 0.1s linear forwards 3.3s;
    position: relative;
    /* 添加相对定位以便于子元素的绝对定位 */
}

.main .main-left .lightning .lightning1 .jd1 .box span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #b6144a;
    /* 文字颜色 */
    font-size: 1rem;
    /* 根据需要调整文字大小 */
    white-space: nowrap;
    /* 防止文字换行 */
}


.main .main-left .lightning .lightning2>div {
    float: left;
}

.main .main-left .lightning .lightning2 .sd2 {
    width: 55%;
    height: 100%;
    overflow: hidden;
}

.main .main-left .lightning .lightning2 .jd2 {
    display: flex;
    align-items: center;
    width: 45%;
    height: 100%;
    margin-top: 10px;
}

.main .main-left .lightning .lightning2 .jd2>div {}

.main .main-left .lightning .lightning2 .jd2 ul {
    display: flex;
    align-items: center;
}

.main .main-left .lightning .lightning2 .jd2 ul li {
    margin-right: 0.15rem;
    background-color: #00e4c8;
    border-radius: 50%;
    opacity: 0;
}

.main .main-left .lightning .lightning2 .jd2 ul li:nth-of-type(1) {
    width: 0.6rem;
    height: 0.6rem;
    animation: show4 0.1s linear forwards 2.5s;
}

.main .main-left .lightning .lightning2 .jd2 ul li:nth-of-type(2) {
    width: 0.7rem;
    height: 0.7rem;
    animation: show4 0.1s linear forwards 2.6s;
}

.main .main-left .lightning .lightning2 .jd2 ul li:nth-of-type(3) {
    width: 0.8rem;
    height: 0.8rem;
    animation: show4 0.1s linear forwards 2.7s;
}

.main .main-left .lightning .lightning2 .jd2 ul li:nth-of-type(4) {
    width: 0.9rem;
    height: 0.9rem;
    animation: show4 0.1s linear forwards 2.8s;
}

.main .main-left .lightning .lightning2 .jd2 .box {
    width: 6rem;
    height: 2.6rem;
    background-color: #00e4c8;
    border-radius: 0.4rem;
    opacity: 0;
    animation: show4 0.1s linear forwards 3.3s;
    position: relative;
}

.main .main-left .lightning .lightning2 .jd2 .box span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #b6144a;
    font-size: 1rem;
    white-space: nowrap;
}

.main .main-left .top3 {
    width: 100%;
    height: 30%;
    position: relative;
}

.main .main-left .top3 ul {
    width: 60%;
    height: 100%;
    position: absolute;
    left: -50%;
    top: 0;
    transform: translateX(-50%);
    animation: animate1 1s linear forwards 3s;
}

.main .main-left .top3 ul li {
    float: left;
    width: 30%;
    height: 100%;
    margin: 0 1.5%;
}

.main .main-left .top3 ul li:nth-of-type(1) {
    background: url("../../assets/threePhase/1.png") no-repeat center bottom;
    background-size: 70%;
}

.main .main-left .top3 ul li:nth-of-type(1) .title {
    width: 100%;
    text-align: center;
    color: #ff7a9a;
    font-size: 0.8rem;
    margin-top: -5%;
}

.main .main-left .top3 ul li:nth-of-type(1) .content {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-top: 10%;
}

.main .main-left .top3 ul li:nth-of-type(1) .content p {
    font-size: 0.3rem;
}

.main .main-left .top3 ul li:nth-of-type(1) .content span {
    font-size: 0.5rem;
    display: block;
}

.main .main-left .top3 ul li:nth-of-type(2) {
    background: url("../../assets/threePhase/2.png") no-repeat center bottom;
    background-size: 70%;
}

.main .main-left .top3 ul li:nth-of-type(2) .title {
    width: 100%;
    text-align: center;
    color: #01c793;
    font-size: 0.8rem;
    margin-top: 20%;
}

.main .main-left .top3 ul li:nth-of-type(2) .content {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-top: 10%;
}

.main .main-left .top3 ul li:nth-of-type(2) .content p {
    font-size: 0.3rem;
}

.main .main-left .top3 ul li:nth-of-type(2) .content span {
    font-size: 0.5rem;
    display: block;
}

.main .main-left .top3 ul li:nth-of-type(3) {
    background: url("../../assets/threePhase/3.png") no-repeat center bottom;
    background-size: 70%;
}

.main .main-left .top3 ul li:nth-of-type(3) .title {
    width: 100%;
    text-align: center;
    color: #01c2aa;
    font-size: 0.8rem;
    margin-top: 43%;
}

.main .main-left .top3 ul li:nth-of-type(3) .content {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-top: 10%;
}

.main .main-left .top3 ul li:nth-of-type(3) .content p {
    font-size: 0.3rem;
}

.main .main-left .top3 ul li:nth-of-type(3) .content span {
    font-size: 0.3rem;
    display: block;
}

.main .main-middle {
    width: 55%;
    height: 100%;
    position: relative;
}

.main .main-middle .external1 {
    width: 15%;
    height: 100%;
    background: url("../../assets/threePhase/border1.png") no-repeat left;
    background-size: contain;
    position: absolute;
    left: 40%;
    top: 0;
    opacity: 0;
    animation: come1 0.5s linear forwards 1.4s;
}

.main .main-middle .external2 {
    width: 15%;
    height: 100%;
    background: url("../../assets/threePhase/border2.png") no-repeat right;
    background-size: contain;
    position: absolute;
    right: 40%;
    top: 0;
    opacity: 0;
    animation: come2 0.5s linear forwards 1.4s;
}

.main .main-middle .external3 {
    width: 60%;
    height: 10%;
    background: url("../../assets/threePhase/border3.png") no-repeat center top;
    background-size: contain;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 15%;
    opacity: 0;
    animation: come3 0.5s linear forwards 1.4s;
}

.main .main-middle .external4 {
    width: 60%;
    height: 10%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    background: url("../../assets/threePhase/border4.png") no-repeat center bottom;
    background-size: contain;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    bottom: 10%;
    animation: come4 0.5s linear forwards 1.4s;
}

.main .main-middle .external4 p {
    /* 这里添加项目名称 */
    position: absolute;
    right: 0;
    bottom: -30px;
    color: #00c5df;
    font-size: 24px;
    flex-wrap: 600;
}

.main .main-middle .jz1,
.main .main-middle .jz2 {
    opacity: 0;
    animation: show4 0.1s linear forwards 1.8s;
}

.main .main-middle .jz1 ul,
.main .main-middle .jz2 ul {
    width: 30%;
    height: 38%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
}

.main .main-middle .jz1 ul li,
.main .main-middle .jz2 ul li {
    width: 100%;
    height: 8%;
    margin: 40% 0;
    background-color: #ff7a9a;
}

.main .main-middle .jz1 {
    width: 4%;
    height: 100%;
    background-color: red;
    background: url("../../assets/threePhase/jz.png") no-repeat center;
    background-size: contain;
    position: absolute;
    left: 5%;
    top: 0;
}

.main .main-middle .jz2 {
    width: 4%;
    height: 100%;
    background-color: red;
    background: url("../../assets/threePhase/jz.png") no-repeat center;
    background-size: contain;
    position: absolute;
    right: 5%;
    top: 0;
}

.main .main-middle .inner1 {
    width: 10%;
    height: 100%;
    position: absolute;
    left: 10%;
    top: 0;
    opacity: 0;
    background: url("../../assets/threePhase/leftBorder.png") no-repeat center;
    background-size: 100%;
    animation: inner1 0.3s linear forwards 1.9s;
}

.main .main-middle .inner2 {
    width: 10%;
    height: 100%;
    position: absolute;
    right: 10%;
    top: 0;
    opacity: 0;
    background: url("../../assets/threePhase/rightBorder.png") no-repeat center;
    background-size: 100%;
    animation: inner2 0.3s linear forwards 1.9s;
}

.main .main-middle .arrow-l {
    position: absolute;
    width: 10%;
    height: 20%;
    left: 15%;
    top: 40%;
    opacity: 0;
    z-index: 2;
    animation: arrow1 1.5s linear infinite 1s;
}

.main .main-middle .arrow-l ol {
    width: 100%;
    height: 100%;
}

.main .main-middle .arrow-l ol li {
    width: 33%;
    height: 100%;
    float: left;
    background: url("../../assets/threePhase/yuan.png") no-repeat center;
    background-size: 60%;
}

.main .main-middle .arrow-l ol li:nth-of-type(3) {
    background: url("../../assets/threePhase/arrow-l.png") no-repeat center;
    background-size: 80%;
}

.main .main-middle .arrow-r {
    position: absolute;
    width: 10%;
    height: 20%;
    right: 15%;
    top: 40%;
    opacity: 0;
    z-index: 2;
    animation: arrow2 1.5s linear infinite 1s;
}

.main .main-middle .arrow-r ol {
    width: 100%;
    height: 100%;
}

.main .main-middle .arrow-r ol li {
    width: 33%;
    height: 100%;
    float: right;
    background: url("../../assets/threePhase/yuan.png") no-repeat center;
    background-size: 60%;
}

.main .main-middle .arrow-r ol li:nth-of-type(3) {
    background: url("../../assets/threePhase/arrow-r.png") no-repeat center;
    background-size: 80%;
}

.main .main-middle .meter {
    width: 50%;
    height: 60%;
    background-color: rgba(255, 255, 255, 0.2);
    background: url("../../assets/threePhase/huan.png") no-repeat center;
    background-size: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    opacity: 0;
    z-index: 2;
    transform: translate(-50%, -50%);
    animation: meter 3s linear forwards 1.1s;
}

.main .main-middle .animate {
    width: 70%;
    height: 70%;
    // z-index: -1;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    animation: animate 1s linear forwards 1s;
    border-radius: 20rem;
    overflow: hidden;
}

.main .main-middle .animate canvas {
    transform-origin: 0 0;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 40%;
}

.main .main-middle .sale {
    width: 26rem;
    height: 26rem;
    background: url("../../assets/threePhase/cicle.png") no-repeat center;
    background-size: contain;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -13rem;
    margin-top: -13rem;
    opacity: 0;
    animation: sale 1s linear forwards 1s;
}

.main .main-middle .sale p {
    width: 100%;
    height: 20%;
    text-align: center;
    color: #fff;
    display: table;
    font-size: 3rem;
}

.main .main-middle .sale p span {
    display: table-cell;
    vertical-align: middle;
}

.main .main-middle .sale p:nth-of-type(1) {
    margin-top: 30%;
}

.main .main-middle .sale p:nth-of-type(2) {
    font-family: 'YeJingShuZi', sans-serif;
    font-size: 3.5rem;
}

.main .main-right {
    width: 22.5%;
    height: 100%;
}

.main .main-right .compare {
    width: 100%;
    height: 30%;
    position: relative;
}

.main .main-right .compare .compare-content {
    width: 10rem;
    height: 10rem;
    background: url("../../assets/threePhase/border02.png") no-repeat center;
    background-size: contain;
    position: absolute;
    left: 150%;
    top: 50%;
    transform: translate(-50%, -50%);
    animation: animate2 1s linear forwards 3s;
}

.main .main-right .compare .compare-content .rate2 {
    width: 6rem;
    height: 6rem;
    position: absolute;
    left: 25%;
    top: 51%;
    transform: translateY(-50%);
    background: url("../../assets/threePhase/cricle.png") no-repeat center;
    background-size: contain;
    animation: rotate1 4s ease infinite;
}

.main .main-right .compare .compare-content .rate2 h5 {
    text-align: center;
    height: 50%;
    width: 100%;
    color: #fff;
    display: table;
}

.main .main-right .compare .compare-content .rate2 h5 span {
    display: table-cell;
    vertical-align: bottom;
    font-size: 0.8rem;
}

.main .main-right .compare .compare-content .rate2 p {
    text-align: center;
    height: 50%;
    width: 100%;
    color: #fff;
    display: table;
}

.main .main-right .compare .compare-content .rate2 p span {
    display: table-cell;
    vertical-align: middle;
}

.main .main-right .lightning {
    width: 100%;
    height: 40%;
}

.main .main-right .lightning .lightning3,
.main .main-right .lightning .lightning4 {
    width: 100%;
    height: 50%;
    display: flex;
}

.main .main-right .lightning .lightning3>div {
    float: left;
}

.main .main-right .lightning .lightning3 .jd3 {
    width: 45%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    margin-top: 10px;
}

.main .main-right .lightning .lightning3 .jd3>div {
    // float: right;
}

.main .main-right .lightning .lightning3 .jd3 ul {
    // float: right;
    // margin-top: 30%;
    display: flex;
    align-items: center;
}

.main .main-right .lightning .lightning3 .jd3 ul li {
    // float: right;
    margin-left: 0.15rem;
    background-color: #00e4c8;
    border-radius: 50%;
    opacity: 0;
}

.main .main-right .lightning .lightning3 .jd3 ul li:nth-of-type(1) {
    width: 0.9rem;
    height: 0.9rem;
    animation: show4 0.1s linear forwards 2.8s;
}

.main .main-right .lightning .lightning3 .jd3 ul li:nth-of-type(2) {
    width: 0.8rem;
    height: 0.8rem;
    animation: show4 0.1s linear forwards 2.7s;
}

.main .main-right .lightning .lightning3 .jd3 ul li:nth-of-type(3) {
    width: 0.7rem;
    height: 0.7rem;
    animation: show4 0.1s linear forwards 2.6s;
}

.main .main-right .lightning .lightning3 .jd3 ul li:nth-of-type(4) {
    width: 0.6rem;
    height: 0.6rem;
    animation: show4 0.1s linear forwards 2.5s;
}

.main .main-right .lightning .lightning3 .jd3 .box {
    width: 6rem;
    height: 2.6rem;
    background-color: #00e4c8;
    border-radius: 0.4rem;
    opacity: 0;
    animation: show4 0.1s linear forwards 3.3s;
    position: relative;
}

.main .main-right .lightning .lightning3 .jd3 .box span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #b6144a;
    font-size: 1rem;
    white-space: nowrap;
}

.main .main-right .lightning .lightning3 .sd3 {
    width: 55%;
    height: 100%;
    margin-left: 10px;
}

.main .main-right .lightning .lightning4>div {
    float: left;
}

.main .main-right .lightning .lightning4 .jd4 {
    width: 45%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    margin-top: 10px;
}

.main .main-right .lightning .lightning4 .jd4>div {
    // float: right;
}

.main .main-right .lightning .lightning4 .jd4 ul {
    // float: right;
    // margin-top: 30%;
    display: flex;
    align-items: center;
}

.main .main-right .lightning .lightning4 .jd4 ul li {
    // float: right;
    margin-left: 0.15rem;
    background-color: #00e4c8;
    border-radius: 50%;
    opacity: 0;
}

.main .main-right .lightning .lightning4 .jd4 ul li:nth-of-type(1) {
    width: 0.9rem;
    height: 0.9rem;
    animation: show4 0.1s linear forwards 2.8s;
}

.main .main-right .lightning .lightning4 .jd4 ul li:nth-of-type(2) {
    width: 0.8rem;
    height: 0.8rem;
    animation: show4 0.1s linear forwards 2.7s;
}

.main .main-right .lightning .lightning4 .jd4 ul li:nth-of-type(3) {
    width: 0.7rem;
    height: 0.7rem;
    animation: show4 0.1s linear forwards 2.6s;
}

.main .main-right .lightning .lightning4 .jd4 ul li:nth-of-type(4) {
    width: 0.6rem;
    height: 0.6rem;
    animation: show4 0.1s linear forwards 2.5s;
}

.main .main-right .lightning .lightning4 .jd4 .box {
    width: 6rem;
    height: 2.6rem;
    background-color: #00e4c8;
    border-radius: 0.4rem;
    opacity: 0;
    animation: show4 0.1s linear forwards 3.3s;
    position: relative;
}

.main .main-right .lightning .lightning4 .jd4 .box span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #b6144a;
    font-size: 1rem;
    white-space: nowrap;
}

.main .main-right .lightning .lightning4 .sd4 {
    width: 55%;
    height: 100%;
    margin-left: 10px;
}

.main .main-right .top6 {
    width: 100%;
    height: 30%;
    position: relative;
}

.main .main-right .top6 ul {
    width: 60%;
    height: 100%;
    position: absolute;
    left: 150%;
    top: 0;
    transform: translateX(-50%);
    animation: animate2 1s linear forwards 3s;
}

.main .main-right .top6 ul li {
    float: left;
    width: 30%;
    height: 100%;
    margin: 0 1.5%;
}

.main .main-right .top6 ul li:nth-of-type(1) {
    background: url("../../assets/threePhase/4.png") no-repeat center bottom;
    background-size: 70%;
}

.main .main-right .top6 ul li:nth-of-type(1) .title {
    width: 100%;
    text-align: center;
    color: #cab636;
    font-size: 0.8rem;
    margin-top: 60%;
}

.main .main-right .top6 ul li:nth-of-type(1) .content {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-top: 10%;
}

.main .main-right .top6 ul li:nth-of-type(1) .content p {
    font-size: 0.3rem;
}

.main .main-right .top6 ul li:nth-of-type(1) .content span {
    font-size: 0.5rem;
    display: block;
}

.main .main-right .top6 ul li:nth-of-type(2) {
    background: url("../../assets/threePhase/5.png") no-repeat center bottom;
    background-size: 70%;
}

.main .main-right .top6 ul li:nth-of-type(2) .title {
    width: 100%;
    text-align: center;
    color: #028e4f;
    font-size: 0.8rem;
    margin-top: 78%;
}

.main .main-right .top6 ul li:nth-of-type(2) .content {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-top: 10%;
}

.main .main-right .top6 ul li:nth-of-type(2) .content p {
    font-size: 0.3rem;
}

.main .main-right .top6 ul li:nth-of-type(2) .content span {
    font-size: 0.5rem;
    display: block;
}

.main .main-right .top6 ul li:nth-of-type(3) {
    background: url("../../assets/threePhase/6.png") no-repeat center bottom;
    background-size: 70%;
}

.main .main-right .top6 ul li:nth-of-type(3) .title {
    width: 100%;
    text-align: center;
    color: #01a893;
    font-size: 0.8rem;
    margin-top: 95%;
}

.main .main-right .top6 ul li:nth-of-type(3) .content {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-top: 10%;
}

.main .main-right .top6 ul li:nth-of-type(3) .content p {
    font-size: 0.3rem;
}

.main .main-right .top6 ul li:nth-of-type(3) .content span {
    font-size: 0.3rem;
    display: block;
}

.bottom {
    width: 100%;
    height: 30%;
    position: relative;
    overflow: hidden;
}

.bottom .ul-box {
    width: 200%;
    height: 100%;
    position: relative;
    animation: move 10s linear infinite 6s;
}

.bottom .ul-box:hover{
    animation-play-state: paused;
}

.bottom .ul-box ul {
    float: left;
    width: 50%;
    height: 100%;
}

.bottom .ul-box ul li {
    width: 30%;
    height: 100%;
    margin: 0 1.5%;
    background: url("../../assets/threePhase/di.png") no-repeat center bottom;
    background-size: 50%;
    float: left;
}

.bottom .ul-box ul li .li-content {
    opacity: 0;
    position: relative;
    width: 100%;
    height: 60%;
    background: url("../../assets/threePhase/bg.png") no-repeat center;
    background-size: contain;
    overflow: hidden;
    animation: show5 1s linear forwards 4s;
}

.bottom .ul-box ul li .li-content p {
    width: 100%;
    height: 20%;
    text-align: center;
    color: #fff;
    display: table;
}

.bottom .ul-box ul li .li-content p span {
    display: table-cell;
    vertical-align: middle;
}

.bottom .ul-box ul li .li-content p:nth-of-type(1) {
    margin-top: 10%;
    font-size: 1.8rem;
}

.bottom .ul-box ul li .li-content p:nth-of-type(2) {
    font-family: 'YeJingShuZi';
    font-size: 2.8rem;
}

.bottom .ul-box ul li .li-content .li-box {
    position: absolute;
    width: 70%;
    height: 80%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.bottom .ul-box ul li .li-content .li-box .box1,
.bottom .ul-box ul li .li-content .li-box .box2,
.bottom .ul-box ul li .li-content .li-box .box3,
.bottom .ul-box ul li .li-content .li-box .box4 {
    width: 23%;
    height: 50%;
    position: absolute;
}

.bottom .ul-box ul li .li-content .li-box .box1 h5,
.bottom .ul-box ul li .li-content .li-box .box2 h5,
.bottom .ul-box ul li .li-content .li-box .box3 h5,
.bottom .ul-box ul li .li-content .li-box .box4 h5 {
    height: 50%;
    color: #fff;
    font-size: 1rem;
    font-weight: normal;
    display: table;
}

.bottom .ul-box ul li .li-content .li-box .box1 h5 span,
.bottom .ul-box ul li .li-content .li-box .box2 h5 span,
.bottom .ul-box ul li .li-content .li-box .box3 h5 span,
.bottom .ul-box ul li .li-content .li-box .box4 h5 span {
    display: table-cell;
    vertical-align: middle;
}

.bottom .ul-box ul li .li-content .li-box .box1 .pic,
.bottom .ul-box ul li .li-content .li-box .box2 .pic,
.bottom .ul-box ul li .li-content .li-box .box3 .pic,
.bottom .ul-box ul li .li-content .li-box .box4 .pic {
    width: 100%;
    height: 50%;
    color: #fff;
    font-size: 1rem;
}

.bottom .ul-box ul li .li-content .li-box .box1 .pic img,
.bottom .ul-box ul li .li-content .li-box .box2 .pic img,
.bottom .ul-box ul li .li-content .li-box .box3 .pic img,
.bottom .ul-box ul li .li-content .li-box .box4 .pic img {
    width: 1rem;
    vertical-align: bottom;
    margin-right: 5%;
}

.bottom .ul-box ul li .li-content .li-box .box1 {
    left: 0;
    top: 0;
}

.bottom .ul-box ul li .li-content .li-box .box2 {
    right: 0;
    top: 0;
}

.bottom .ul-box ul li .li-content .li-box .box3 {
    left: 0;
    bottom: 0;
}

.bottom .ul-box ul li .li-content .li-box .box4 {
    right: 0;
    bottom: 0;
}

.bottom .ul-box ul li:nth-of-type(1) {
    transform: translateY(100%);
    animation: di2 1s linear forwards 3s;
}

.bottom .ul-box ul li:nth-of-type(2) {
    transform: translateY(100%);
    animation: di2 1s linear forwards 3s;
}

.bottom .ul-box ul li:nth-of-type(3) {
    transform: translateY(100%);
    animation: di2 1s linear forwards 3s;
}

.chart-container {
    position: relative;
    width: 80%;
    /* 根据需要调整宽度 */
    height: 550px;
    /* 根据需要调整高度 */
    margin: 0 auto;
    /* 使容器居中 */
    padding: 50px;
    /* 添加内边距以避免内容紧贴边缘 */
    background-color: transparent;
    /* 设置背景颜色为透明 */
}

@keyframes show1 {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 0.25;
    }
}

@keyframes show2 {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 0.5;
    }
}

@keyframes show3 {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 0.75;
    }
}

@keyframes show4 {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes zoomIn {
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }

    100% {
        opacity: 1;
    }
}

@keyframes come1 {
    0% {
        opacity: 0;
        left: 40%;
    }

    100% {
        opacity: 1;
        left: 0;
    }
}

@keyframes come2 {
    0% {
        opacity: 0;
        right: 40%;
    }

    100% {
        opacity: 1;
        right: 0;
    }
}

@keyframes come3 {
    0% {
        opacity: 0;
        top: 40%;
    }

    100% {
        opacity: 1;
        top: 15%;
    }
}

@keyframes come4 {
    0% {
        opacity: 0;
        bottom: 40%;
    }

    100% {
        opacity: 1;
        bottom: 10%;
    }
}

@keyframes rotate1 {
    0% {
        transform: translateY(-50%) rotateY(0);
    }

    100% {
        transform: translateY(-50%) rotateY(360deg);
    }
}

@keyframes inner1 {
    0% {
        left: 40%;
        opacity: 0;
    }

    100% {
        left: 10%;
        opacity: 1;
    }
}

@keyframes inner2 {
    0% {
        right: 40%;
        opacity: 0;
    }

    100% {
        right: 10%;
        opacity: 1;
    }
}

@keyframes arrow1 {
    0% {
        opacity: 0.2;
        left: 10%;
    }

    100% {
        opacity: 1;
        left: 15%;
    }
}

@keyframes arrow2 {
    0% {
        opacity: 0.2;
        right: 10%;
    }

    100% {
        opacity: 1;
        right: 15%;
    }
}

@keyframes meter {
    0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0) rotate(0);
    }

    40% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(0.8) rotate(360deg);
    }

    80% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(0.8) rotate(540deg);
    }

    100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1) rotate(540deg);
    }
}

@keyframes animate {
    0% {
        opacity: 0;
    }

    100% {
        opacity: .7;
    }
}

@keyframes sale {
    from {
        opacity: 0;
        -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
        -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    60% {
        opacity: 1;
        -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }

    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1) translate3d(0, 60px, 0);
        transform: scale3d(1, 1, 1) translate3d(0, 0, 0);
        -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }
}

@keyframes animate1 {
    0% {
        left: -50%;
    }

    100% {
        left: 50%;
    }
}

@keyframes animate2 {
    0% {
        left: 150%;
    }

    100% {
        left: 50%;
    }
}

@keyframes di2 {
    0% {
        transform: translateY(100%);
    }

    100% {
        transform: translateY(0);
    }
}

@keyframes show5 {
    0% {
        opacity: 0;
        transform: translateY(100%) scale(0);
    }

    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes move {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}
</style>